"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "borderRadius", {
    enumerable: true,
    get: function() {
        return borderRadius;
    }
});
const borderRadius = {
    borderRadiusNone: '0',
    borderRadiusSmall: '2px',
    borderRadiusMedium: '4px',
    borderRadiusLarge: '6px',
    borderRadiusXLarge: '8px',
    borderRadius2XLarge: '12px',
    borderRadius3XLarge: '16px',
    borderRadius4XLarge: '24px',
    borderRadius5XLarge: '32px',
    borderRadius6XLarge: '40px',
    borderRadiusCircular: '10000px'
};
